import signInAction from "@actions/signInAction"
import downloadRedirectLoader from "@loaders/downloadRedirectLoader"
import getSubscriptionLoader from "@loaders/getSubscriptionLoader"
import ConfirmEmailPage from "@pages/account/ConfirmEmailPage"
import ForgotPasswordPage from "@pages/account/ForgotPasswordPage"
import ResetPasswordPage from "@pages/account/ResetPasswordPage"
import SignInPage from "@pages/account/SignInPage"
import SubscriptionPage from "@pages/account/SubscriptionPage"
import { Navigate } from "react-router-dom"

const accountRoutes = [
  {
    index: true,
    element: <Navigate to="subscription" replace />,
  },
  {
    // NOTE: Linked from Supabase Auth emails (e.g. confirming a changed
    // email): the address is in Supabase's allowed redirect URLs.
    element: <ConfirmEmailPage />,
    path: "confirm-email",
  },
  {
    loader: downloadRedirectLoader,
    path: "download",
  },
  {
    element: <ForgotPasswordPage />,
    path: "forgot-password",
  },
  {
    element: <ResetPasswordPage />,
    path: "reset-password",
  },
  {
    action: signInAction,
    element: <SignInPage />,
    path: "sign-in",
  },
  {
    element: <SubscriptionPage />,
    loader: getSubscriptionLoader,
    path: "subscription",
  },
]

export default accountRoutes
